import { type IOffer } from "../../../store/slices/offersSlice"

export const getOfferTypeName = (offer: IOffer | undefined): 'sale-commercial' |  'sale' | 'residential' | 'commercial' | "" => {
    const typeOffer = offer?.attributes?.Type?.[0]?.__component?.split('.')[1] ?? ''
    if (typeOffer === 'sale-commercial' || typeOffer === 'sale' || typeOffer === 'residential' || typeOffer === 'commercial') {
        return typeOffer;
    }
    return '';
}
